// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"43809c3066f294db31b7","453":"98a3a16ee7ee15c953f2","454":"5bae395f293e5656ecff"}[chunkId] + ".js";
};